(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvTitleBar', drvTitleBar);

    drvTitleBar.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvTitleBar
     * 
     * @description
     * For presenting a title bar with consistent style in the various "edit" views,
     * e.g. edit entity, edit task, etc.
     * 
     * # Scope Properties
     * {string} titleText
     * {int} titleCount - Shows a count next to the title text.
     * {string} titleIconUsage - The icons usage, e.g. 'document template', 'entity template'
     * {string} titleIcon - Name of an SVG icon
     * {string} titleIconColour
     * {string} titleHelpText
     * {function} closeOnClick - Callback triggered when the 'close' button is clicked
     * {bool} closeDisabled
     * {bool} menuBarDisabled
     * {bool} hideMenuBar
     * {bool} hideClose
     * {function} fullscreen - Callback triggered when the 'fullscreen' button is clicked
     * {string} buttonFooterText - Optional. Text which will appear below the primary button. This can be used for showing Last Updated text.
     * {bool} subViewMode - Is the title bar being shown as part of a 'sub-view'? If so then it should be styled differently.
     */
    function drvTitleBar() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: TitleBarCtrl,
            controllerAs: 'vm',
            transclude: {
                menuBar: 'menuBar',
                buttonBar: 'buttonBar'
            },
            bindToController: {
                titleText: '<',
                titleCount: '<?',
                titleIconUsage: '<?',
                titleIcon: '<?',
                titleIconColour: '<?',
                titleHelpText: '<?',
                closeOnClick: '&?',
                closeDisabled: '<?',
                menuBarDisabled: '<?',
                hideMenuBar: '<?',
                hideClose: '<?',
                fullscreen: '&?',
                buttonFooterText: '<?',
                subViewMode: '<?'
            },
            templateUrl: 'app/Controls/titlebar/title-bar.tmpl.html'
        };
        return directive;

        function TitleBarCtrl() {}
    }
})();